import { INiche } from "@/common/services/types";
import { Columnizer } from "components/blocks/Columnizer";
import { NicheBlockPlaceholder } from "components/UI/Skeleton/Skeleton";
import { clsx } from "clsx";
import { useFollowingNiche } from "@/common/hooks/useFollowingNiche";

import "./index.scss";
import { NicheCatalogItem } from "../NicheCatalogItem/NicheCatalogItem";
import { ReactElement, useMemo } from "react";
import { InfiniteScroll } from "@/components/utils/InfiniteScroll";
import { useSfw } from "@/common/hooks/useSfw";

/* eslint-disable no-magic-numbers */

const COLUMN_SIZES = [500];

/* eslint-enable no-magic-numbers */

export const NicheCatalog = (props: {
  niches: INiche[];
  myNiche?: boolean;
  isLoading: boolean;
  withPreview?: boolean;
  hasMore: boolean;
  fetchMore: () => void;
}): ReactElement => {
  const { onFollow, isFollowing } = useFollowingNiche();
  const { sanitizeNiche, isLoading: sfwLoading } = useSfw();

  const isLoading = useMemo(() => props.isLoading || sfwLoading, [props.isLoading, sfwLoading]);

  const classes = clsx([
    "niches",
    "nicheCatalog"
  ]);

  const renderNiches = () => {
    if (!props.niches.length && isLoading) {
      // eslint-disable-next-line no-magic-numbers
      return new Array(!props.withPreview ? 50 : 8).fill("").map((___, index) => <NicheBlockPlaceholder key={index} />);
    }

    if (!props.niches.length && !isLoading) {
      return <p>No niches to show on this page.</p>;
    }

    return props.niches.map((item: INiche) => {
      const niche = sanitizeNiche(item);

      return (
        <NicheCatalogItem
          key={niche.id}
          niche={niche}
          following={isFollowing(niche.id)}
          onFollow={onFollow}
          withJoin={!props.myNiche}
          withPreview={props.withPreview}
        />
      );
    });
  };

  return (
    <div className={classes}>
      <InfiniteScroll
        fetchMore={props.fetchMore}
        hasMore={props.hasMore}
      >
        <Columnizer sizes={COLUMN_SIZES}>
          {renderNiches()}
        </Columnizer>
      </InfiniteScroll>
    </div>
  );
};
